import store from '@/store';
import { referralDataRepository } from '@/forms/api/repository-factory';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';
import callApi from '@/lib/helpers/call-api';

const getPayload = () => {
    const { values } = store.state.formData;
    const { referalCif } = store.state;
    const { customerExist } = store.state;
    const firstName = getValueByFieldName(values, FIELD_NAMES.firstName);
    const lastName = getValueByFieldName(values, FIELD_NAMES.lastName);
    const email = getValueByFieldName(values, FIELD_NAMES.email);
    const mobileNumber = getValueByFieldName(values, FIELD_NAMES.phoneNumber);
    const referFirstName = getValueByFieldName(values, FIELD_NAMES.referFirstName);
    const referLastName = getValueByFieldName(values, FIELD_NAMES.referLastName);
    const referEmail = getValueByFieldName(values, FIELD_NAMES.referEmail);
    const referMobileNumber = getValueByFieldName(values, FIELD_NAMES.referMobileNumber);


    return {
        "referral": {
            "first-name": firstName,
            "last-name": lastName,
            "email-address": email,
            "mobile-number": mobileNumber,
            "cif": referalCif ? referalCif : "",
            "existing-customer": customerExist,

            "referred": {
                "first-name": referFirstName,
                "last-name": referLastName,
                "email-address": referEmail,
                "mobile-number": referMobileNumber
            }
        }
    };
};

export default {
    async referralData(currentStep, callbacks) {
        const { form } = currentStep;
        let response = false;
        response = await callApi({
            callbacks,
            form,
            formElement: currentStep,
            apiCall: referralDataRepository.referralData,
            payload: getPayload(),
        });
        if (response) {
            const referalResponse = response;

        }
    }
};
